export enum TableSortValues {
  AlwaysFirst = 'TableSortAlwaysFirst',
  AlwaysLast = 'TableSortAlwaysLast',
}
